import { render, staticRenderFns } from "./RegisterSegment.vue?vue&type=template&id=3c111e37"
import script from "./RegisterSegment.vue?vue&type=script&lang=js"
export * from "./RegisterSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports